import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { PatientFormComponent } from '../../../Forms';
import { PatientFormValues } from '../../../Forms/Patient';
import { SubmissionErrors, FormApi } from 'final-form';

const PatientFormCard = (props: {
  initialValues?: PatientFormValues;
  loading?: boolean;
  onSubmit: (
    values: PatientFormValues,
    form: FormApi<PatientFormValues>,
    callback?: (errors?: SubmissionErrors) => void,
  ) =>
    | SubmissionErrors
    | Promise<SubmissionErrors | undefined>
    | undefined
    | void;
}) => (
  <Card>
    <CardBody>
      <CardTitle>
        <h1>Patient Form</h1>
      </CardTitle>
      <hr />
      <PatientFormComponent {...props} />
    </CardBody>
  </Card>
);

export default PatientFormCard;
